// if (NODE_ENV !== 'development') {
// 	var con = {};
// 	Object.keys(window.console).forEach(key => {
// 		con[key] = function() {};
// 	});
// 	window.console = con;
// }
if (NODE_ENV !== 'development') {
	console.log(`%c platform was built at: ${PLATFORM_VERSION} `, 'background:#222;color:#bada55');
}
import 'babel-polyfill';
import ajax from './api/ajax.js';
import cacheTools from './api/cacheTools';
import { getMultiLang } from './api/getMultiLang';
import { MutiInit as _MutiInit, getIntl } from './Page/MutiInit';
import pageTo from './api/pageTo';
import NCSelect from './base/nc_Select';
import NCButton from './base/nc_Button';
import NCCheckbox from './base/nc_Checkbox';
import NCStep from './base/nc_Step';
import viewModel from './shell/viewmodel/viewmodel';

// 添加aes加密的操作库 bbqin
import * as Cipher from './api/cipher';

const base = {
	NCSelect,
	NCButton,
	NCCheckbox,
	NCStep
};

const mutiInit = {
	init: _MutiInit.bind(this),
	getIntl: getIntl.bind(this)
};

export { ajax, mutiInit, getMultiLang, cacheTools, pageTo, base, Cipher, viewModel };
